import React, { useContext } from 'react';
import ThemeContext from '../theme/ThemeContext';

const PanelBody: React.FC<{}> = (props) => {
  const theme = useContext(ThemeContext);
  return (
    <div className={`${theme.mode === 'admin' ? 'panel-body' : 'card-body'}`}>{props.children}</div>
  );
};

export default PanelBody;
